"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDistance = exports.DistanceUnit = void 0;
var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["KM"] = "km";
    DistanceUnit["M"] = "m";
    DistanceUnit["MI"] = "mi";
    DistanceUnit["FT"] = "ft";
})(DistanceUnit || (exports.DistanceUnit = DistanceUnit = {}));
const TO_METERS = {
    [DistanceUnit.KM]: 1000,
    [DistanceUnit.M]: 1,
    [DistanceUnit.MI]: 1609.34,
    [DistanceUnit.FT]: 0.3048,
};
const convertDistance = (source, target, options) => {
    const multiplier = source.unit === target ? 1 : TO_METERS[source.unit] / TO_METERS[target];
    const converted = source.value * multiplier;
    const rounded = options?.precision === undefined ? converted : parseFloat(converted.toFixed(options?.precision));
    return { value: rounded, unit: target };
};
exports.convertDistance = convertDistance;
